/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VmEmbed } from '@vime/core';
import { define } from '../lib';
define('vm-embed', VmEmbed);
export default Vue.extend({
    props: {
        embedSrc: {},
        mediaTitle: {},
        params: {},
        origin: {},
        preconnections: {},
        decoder: {},
    },
    methods: {
        postMessage: method('postMessage'),
    },
    render: render('vm-embed', ['vmEmbedSrcChange', 'vmEmbedMessage', 'vmEmbedLoaded']),
});
//# sourceMappingURL=Embed.js.map